import { Box, Typography, Button, Modal, Stack } from "@mui/material";
import React from "react";

interface ConfirmDeleteModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
}

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  open,
  onClose,
  onConfirm,
  isDeleting,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute" as const,
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 360,
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 2,
          p: 3,
          outline: "none",
        }}
      >
        <Typography variant="h6" fontWeight={600} mb={1.5}>
          Confirm Deletion
        </Typography>
        <Typography variant="body2" mb={3}>
          Are you sure you want to delete this tour program?
        </Typography>

        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={onConfirm}
            disabled={isDeleting} // ✅ prevent double-click
          >
          {isDeleting ? "Deleting..." : "Delete"}

          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default ConfirmDeleteModal;